import React from 'react';
import '../../../styles/global.css';

function JIPCAD() {
  return (
    <div className="body-container">
      <h1>JIPCAD</h1>
      <h4>Aug 2020 - April 2024</h4>
      <h2>Explore the JIPCAD site <a href='https://jipcad.github.io/' target="_blank" rel="noopener noreferrer">here</a> and the codebase <a href='https://github.com/JIPCAD/JIPCAD' target="_blank" rel="noopener noreferrer">here</a>.</h2>
      <p>JIPCAD is a script-based CAD program developed by a team of students at UC Berkeley. I have developed code in C++ to generate and manipulate 3D geometry.</p>
    
      <h3>Sweeps:</h3>
      <p><b>The EECS Tech Report documenting my work on sweeps can be found <a href='https://www2.eecs.berkeley.edu/Pubs/TechRpts/2024/EECS-2024-13.html' target="_blank" rel="noopener noreferrer">here</a>.</b></p>
      <p>A "sweep" is a piece of geometry that takes a 2D shape (i.e. cross-section) and extrudes it along a curve. A "sweep morph" is a sweep that can change cross-sections at various points along the sweep. Below are two demos of sweep morphs. The sliders control various parameters of the geometry. For example, the morph_cs slider steps through the frames of the swept geometry and lets us visualize the cross-section at any given frame.</p>
      <div className='imgs-grid'>
        <video src={require('./assets/sweepmorph.mp4')} controls>
          <source src={require("./assets/sweepmorph.mp4")} type="video/mp4" />
        </video>
        <video src={require('./assets/morph-demo.mp4')} controls>
          <source src={require("./assets/morph-demo.mp4")} type="video/mp4" />
        </video>
      </div>

      <h3>Other animated scenes:</h3>
      <div className='imgs-grid'>
        <video src={require('./assets/jitterbug.mp4')} controls>
          <source src={require("./assets/jitterbug.mp4")} type="video/mp4" />
        </video>
        <video src={require('./assets/octa-jitterbug.mp4')} controls>
          <source src={require("./assets/octa-jitterbug.mp4")} type="video/mp4" />
        </video>
        <video src={require('./assets/lily.mp4')} controls>
          <source src={require("./assets/lily.mp4")} type="video/mp4" />
        </video>
      </div>
    </div>
  );
};

export default JIPCAD;
